var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAcca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9167 37.3334C23.0379 37.3334 28 32.3712 28 26.2501C28 20.1289 23.0379 15.1667 16.9167 15.1667C10.7956 15.1667 5.83337 20.1289 5.83337 26.2501C5.83337 32.3712 10.7956 37.3334 16.9167 37.3334Z",
    fill: "#15C480"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5001 28H21.0001C19.7114 28 18.6667 29.0447 18.6667 30.3333V47.8333C18.6667 49.122 19.7114 50.1667 21.0001 50.1667H38.5001C39.7887 50.1667 40.8334 49.122 40.8334 47.8333V30.3333C40.8334 29.0447 39.7887 28 38.5001 28Z",
    fill: "#3987F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.6475 17.6951L32.1475 6.02845C31.9718 5.9112 31.7675 5.84387 31.5565 5.83364C31.3455 5.82342 31.1356 5.87069 30.9494 5.9704C30.7631 6.07012 30.6075 6.21853 30.499 6.39982C30.3905 6.5811 30.3332 6.78843 30.3334 6.9997V30.333C30.3332 30.5443 30.3905 30.7516 30.499 30.9329C30.6075 31.1142 30.7631 31.2626 30.9494 31.3623C31.1356 31.462 31.3455 31.5093 31.5565 31.4991C31.7675 31.4889 31.9718 31.4215 32.1475 31.3043L49.6475 19.6376C49.8076 19.5311 49.9388 19.3867 50.0296 19.2173C50.1203 19.0478 50.1678 18.8586 50.1678 18.6664C50.1678 18.4741 50.1203 18.2849 50.0296 18.1154C49.9388 17.946 49.8076 17.8016 49.6475 17.6951Z",
    fill: "#FFC82A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAcca);
export default __webpack_public_path__ + "static/media/icon_acca.720ca60d.svg";
export { ForwardRef as ReactComponent };